"use client";

import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { AuthenticationStep } from "@/lib/analytics/segmentEvents";
import { trackAuthFlow } from "@/lib/analytics/trackEvents";
import LoginDiscoveryForm from "./_components/LoginDiscoveryForm";

export default function Discovery() {
  const searchParams = useSearchParams();
  const pw = searchParams.has("pw");
  const orgType = searchParams.get("orgType");
  const redirectUrl = searchParams.get("redirect");
  const error = searchParams.get("error");

  useEffect(() => {
    if (redirectUrl) {
      fetch("/api/auth/set-redirect", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ redirectUrl }),
      });
    }
  }, [redirectUrl]);

  useEffect(() => {
    if (orgType) {
      localStorage.setItem("preferredOrgType", orgType);
      trackAuthFlow({
        step: AuthenticationStep.DISCOVERY_PAGE,
        additionalParams: {
          event: "page loaded",
          orgType: orgType,
          hasPasswordOption: pw,
          referrer: document.referrer,
        },
      });
    } else {
      trackAuthFlow({
        step: AuthenticationStep.DISCOVERY_PAGE,
        additionalParams: {
          event: "page loaded",
          hasPasswordOption: pw,
          referrer: document.referrer,
        },
      });
    }
  }, [orgType, pw]);

  return (
    <div className="flex flex-col grow w-full min-h-screen px-nf-ds-12 py-nf-ds-16">
      <div className="flex flex-col grow justify-center max-w-[440px] w-full mx-auto">
        <div className="flex flex-col gap-nf-ds-2 mb-nf-ds-8">
          <h1 className="font-nf-ds-serif text-[48px] leading-[1.05] tracking-[-0.02em] text-nf-ds-black">
            Sign in
          </h1>
          <p className="font-nf-ds-sans text-[15px] text-nf-ds-gray-600">
            Welcome back.
          </p>
        </div>

        {error && (
          <div className="w-full mb-nf-ds-6 rounded-nf-ds-md bg-red-50 border border-red-200 p-nf-ds-3 font-nf-ds-sans text-[13px] text-red-700">
            Something went wrong signing in. Please try again.
          </div>
        )}

        <LoginDiscoveryForm passwordLogin={pw} />

        <p className="font-nf-ds-sans text-[12px] text-nf-ds-gray-500 mt-nf-ds-8">
          By logging in, you agree to our{" "}
          <Link
            target="_blank"
            href="https://www.newform.com/privacy"
            className="text-nf-ds-gray-700 underline underline-offset-2"
          >
            Privacy Policy
          </Link>{" "}
          and{" "}
          <Link
            target="_blank"
            href="https://www.newform.com/terms"
            className="text-nf-ds-gray-700 underline underline-offset-2"
          >
            Terms
          </Link>
          .
        </p>
      </div>
    </div>
  );
}
